import Layout from '../components/Layout';
import Seo from '../components/Seo';
import ProductTemplate from '../components/ProductTemplate';

const ContentSkillsMapper = ({ global }) => {
  return (
    <Layout global={global} withSubscribe={true}>
      <Seo seo={{}} />
      <ProductTemplate name="Content to Skills Mapper" />
    </Layout>
  );
};

export default ContentSkillsMapper;
